module.exports = "/_next/static/images/cd57f9effe7b379bf2d287c1dc714ea2-WhereCanISeeIt.png.webp";